import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationResponse = {
  status: number;
  data: { success: boolean };
};

/** Clear a conversation's unread count once somebody has opened it. */
export const useMarkConversationReadMutation = () => {
  const mutationFn = useGetMutationFn<{ phone: string }, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while marking the conversation read',
    endpoint: ({ phone }) => `/api/admin/whatsapp/conversation/${phone}/read`,
    method: 'POST',
  });

  return useMutation<MutationResponse, Error, { phone: string }>({ mutationFn });
};

export const useDeleteContactMutation = () => {
  const mutationFn = useGetMutationFn<{ phone: string }, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while deleting the contact',
    endpoint: ({ phone }) => `/api/admin/whatsapp/contacts/${phone}`,
    method: 'DELETE',
  });

  return useMutation<MutationResponse, Error, { phone: string }>({ mutationFn });
};
